import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "noAuthNotification"
}
const _hoisted_2 = { class: "modal-icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "For security, you have been logged out.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "When you navigate away from this page, any edits in progress will be lost.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppLeftSideBar = _resolveComponent("AppLeftSideBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppContainer = _resolveComponent("AppContainer")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppHeader),
    _createVNode(_component_AppLeftSideBar),
    _createVNode(_component_AppContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    (_ctx.$route.meta.requiresAuth && !_ctx.store.getters.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" You have been logged out: "),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
          }, "Log In Again")
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNoAuthModal)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
          header: _withCtx(() => [
            _createTextVNode(" Not Logged In ")
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                icon: "key",
                size: "3x",
                color: "#FF6F00"
              })
            ]),
            _hoisted_3,
            _hoisted_4
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
            }, " Log In Again "),
            _createElementVNode("button", {
              type: "button",
              class: "secondary",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.suppressNoAuthModal = true), ["prevent"]))
            }, " Close ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}